<template>
    <v-card :height="height" class="support-card ma-1 d-flex flex-column">
        <v-card-title class="d-flex flex-nowrap pa-5 pb-0">
            <p class="text-truncate" style="cursor: pointer" @click="onShowDialog">API</p>
            <v-spacer></v-spacer>
        </v-card-title>
        <v-card-text class="pa-5 pt-0"></v-card-text>
        <v-spacer></v-spacer>
        <v-card-actions>
            <v-col class="text-right">
                <v-btn
                        class=""
                        color="success"
                        text
                        @click="onShowDialog"
                >
                    <v-icon size="45">mdi-eye-outline</v-icon>
                </v-btn>
            </v-col>
        </v-card-actions>
    </v-card>
</template>


<script>

export default {
    name: 'ApiWidget',
    components: {},
    props: {
        height: {
            default: 'auto'
        }
    },
    data() {
        return {
        }
    },
    methods: {
        onShowDialog(){
            this.$router.push({name: 'UserApiPage'});
        }
    },
    computed: {
    }
};
</script>